<script>
import Money from '@src/mixins/money'
import SellerScoreService from '@services/resources/SellerScoreService'
import PageHeader from '@components/page-header'
import Layout from '@layouts/main'
import GraphSeller from '@components/analysis/graph-seller'
import ScoreHistoryItem from '@components/analysis/score-history-item'
import ScoreCount from '@components/analysis/score-count'
import ScoreDetails from './score-details.vue'
import moment from 'moment'

var service = SellerScoreService.build()

export default {
  components: { PageHeader, Layout, GraphSeller, ScoreHistoryItem, ScoreCount, ScoreDetails },
  mixins: [Money],
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      title: 'Análise do vendedor',
      moment: moment,
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Análise do Vendedor',
          active: true,
        },
      ],
      sellerScore: {
        history: []
      },
      loading: false,
      graphLabels: [],
      graphValues: [],
      showGraph: false
    }
  },
  computed: {
    scoreHistory() {
      return this.sellerScore.history || []
    },
  },
  created() {
    this.fetchSellerScore();
  },
  methods: {
   async fetchSellerScore() {
     await service
        .search({ url: `/${this.id}` })
        .then((resp) => {
          this.sellerScore = resp
          const toProccess = resp.history || []
          let labels = [] 
          let payload = []
          toProccess.map(historic => {
            labels.push(moment(historic.model.current.updated_at).format('DD/MM/YY'))
            payload.push(historic.model.current.total_score.toFixed(1))
          })
          this.graphLabels = labels.reverse();
          this.graphValues = payload.reverse();
          this.showGraph = true;

        })
        .catch((err) => {})
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="col-12" style="margin-bottom: 30px;">
            <span class="title-score">
              Score do vendedor
            </span>
          </div>
          <div class="col-12 score-container">
            <ScoreCount :score="sellerScore.total_score" />
            <GraphSeller v-if="showGraph" :labels="graphLabels" :payload="graphValues" />
          </div>
          <div class="col-12 score-container">
            <ScoreDetails :sellerScore="sellerScore" />
          </div>
          <div class="col-12 history-title-container">
            <span class="history-title">Histórico do score</span>
          </div>

          <ScoreHistoryItem v-for="(history, i) in scoreHistory" :key="i" :history="history" />


          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.title-score {
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.2px;
  text-align: left;
  color: black;
  margin-bottom: 30px;
}
.score-container {
  display: flex; flex-wrap: nowrap;
}
.history-title-container {
  margin-top: 40px; 
}
.history-title {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.2px;
  text-align: left;
  color: #000;
}
</style>


